import store from "@/store"
import Qs from 'qs'
import moment from "moment";
import structuredClone from '@ungap/structured-clone';

const axios = require('axios');

function getHeaders() {
    let headers = {"Content-type": "application/json"};
    if (store.state.auth.jwt) {
        headers["Authorization"] = 'Bearer ' + store.state.auth.jwt;
    }
    return headers;
}

const SSO_BASE_URL = process.env.VUE_APP_SSO_API_BASE_URL;
const MEMBERS_BASE_URL = process.env.VUE_APP_MEMBERS_API_BASE_URL;
const TRAINING_BASE_URL = process.env.VUE_APP_TRAINING_API_BASE_URL;
const ACHIEVEMENT_BASE_URL = process.env.VUE_APP_ACHIEVEMENT_API_BASE_URL
const EXCURSION_BASE_URL = process.env.VUE_APP_EXCURSIONS_API_BASE_URL

class EsepMemberService {

    /* ---  User services --- */
    getUserInfo(username = null) {
        username = username ?? store.state.auth.username;
        let url = "/user/" + username;

        return axios.get(SSO_BASE_URL + url, {headers: getHeaders()});
    }

    getAccessibleUnits(username = null, active = false, unitId = null, permission = null) {
        if (null == username) username = store.state.auth.username;
        let url = "/user/" + username + "/permissions";
        let params = {active: active, unitId: unitId, permission: permission};
        return axios.get(SSO_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    getAccessibleReports(username) {
        if (null == username) username = store.state.auth.username;
        let url = "/user/" + username + "/reports";
        return axios.get(SSO_BASE_URL + url, {headers: getHeaders()});
    }

    /* ---  Member services --- */


    getMembersByCriteriaV2(unitIds, statuses, search = null, member_type = null, yearCensus = null, cancelToken = null) {
        let url = "/v2/member";
        let params = {};

        params.search = search;
        params.statuses = statuses;
        params.unitIds = unitIds;
        params.memberTypes = member_type;
        params.yearCensus = yearCensus;

        return axios.get(MEMBERS_BASE_URL + url, {
            cancelToken: cancelToken,
            headers: getHeaders(),
            params: params,
            paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
        });
    }

    getMembersByCriteria(unitIds, statuses, search = null, member_type = null, yearCensus = null, cancelToken = null) {
        let url = "/member";
        let params = {};

        params.search = search;
        params.statuses = statuses;
        params.unitIds = unitIds;
        params.memberTypes = member_type;
        params.yearCensus = yearCensus;

        return axios.get(MEMBERS_BASE_URL + url, {
            cancelToken: cancelToken,
            headers: getHeaders(),
            params: params,
            paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
        });
    }

    getMemberById(memberId) {
        let url = "/member/" + memberId;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    addMember(orgMember) {
        let url = "/member/"
        return axios.post(MEMBERS_BASE_URL + url, orgMember, {headers: getHeaders()})
    }

    deleteMember(memberId, comment, status, deleteActionTitle) {
        let url = "/member/" + memberId + "/update_status";
        return axios.put(MEMBERS_BASE_URL + url, {
            comment: comment,
            status: status,
            deleteActionTitle: deleteActionTitle
        }, {headers: getHeaders()})
    }

    restoreMember(memberId) {
        let url = "/member/" + memberId + "/update_status";
        return axios.put(MEMBERS_BASE_URL + url, {status: "REGISTERED"}, {headers: getHeaders()});
    }

    transferMember(memberId, orgUnit) {
        let url = "/member/" + memberId + "/update_unit";
        return axios.put(MEMBERS_BASE_URL + url, {orgUnit: orgUnit}, {headers: getHeaders()});
    }

    updateMember(orgMember) {
        let url = "/member/" + orgMember.id;
        return axios.put(MEMBERS_BASE_URL + url, orgMember, {headers: getHeaders()});
    }

    getCitizenships() {
        let url = "/reference/NATIONALITY";
        return axios.get(SSO_BASE_URL + url, {headers: getHeaders()});
    }

    getEducationalLevels() {
        let url = "/reference/EDUCATION_LEVEL";
        return axios.get(SSO_BASE_URL + url, {headers: getHeaders()});
    }

    getShirtSizes() {
        let url = "/reference/SHIRT_SIZE";
        return axios.get(SSO_BASE_URL + url, {headers: getHeaders()});
    }

    getMemberTrainings(memberId) {
        let url = `/profile/${memberId}`;
        return axios.get(TRAINING_BASE_URL + url, {headers: getHeaders()});
    }

    /* ---  Old Scouts HQ Commission services --- */

    getOldHQMembersByUnitId(unitIds) {
        let url = "/old_scout_hq/";
        let params = null;
        let status = ['ACTIVE'] + "";
        params = {unitIds: unitIds + "", statuses: status}
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    getOldHQByMemberId(memberId) {
        let url = `/member/${memberId}/old_scout_hq`;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    getOldHQMembersByMemberId(memberIds, statuses) {
        let url = "/old_scout_hq/";
        let params = null;
        params = {memberIds: memberIds + "", statuses: statuses + ""}
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    addOldHQCommission(commission) {
        let url = "/old_scout_hq/";
        commission.startDate = moment(commission.startDate).isValid() ? moment(commission.startDate).format('YYYY-MM-DD') : null;
        commission.endDate = moment(commission.endDate).isValid() ? moment(commission.endDate).format('YYYY-MM-DD') : null;

        return axios.post(MEMBERS_BASE_URL + url, commission, {headers: getHeaders()})
    }

    updateOldHQCommission(commission) {
        let url = "/old_scout_hq/" + commission.id;
        commission.startDate = moment(commission.startDate).isValid() ? moment(commission.startDate).format('YYYY-MM-DD') : null;
        commission.endDate = moment(commission.endDate).isValid() ? moment(commission.endDate).format('YYYY-MM-DD') : null;

        return axios.put(MEMBERS_BASE_URL + url, commission, {headers: getHeaders()})
    }

    /* ---  Unit services --- */

    getOrgUnitById(unitId) {
        let url = "/unit/" + unitId;

        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    addUnit(orgUnit, comment = '') {
        let url = "/unit";
        return axios.post(MEMBERS_BASE_URL + url, {comment: comment, orgUnit: orgUnit}, {headers: getHeaders()})
    }

    updateUnit(orgUnit, comments = '') {
        let url = "/unit/" + orgUnit.id;
        return axios.put(MEMBERS_BASE_URL + url, {comments: comments, orgUnit: orgUnit}, {headers: getHeaders()});
    }

    getDistrictUnits() {
        let url = "/unit"
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: {unitType: "DISTRICT"}})
    }

    getOrgUnitHistoryById(unitId) {
        let url = "/unit/" + unitId + "/history"
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    getUnitLicensesLimits(unitId) {
        let url = "/unit/" + unitId + "/licenses/limits";
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    /* ---  Census services --- */

    getCurrentCensusPeriod() {
        let url = "/census/period/current";
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    getCurrentCensusPeriodForUnit(unitId) {
        let url = `/census/period/unit/${unitId}`;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    getCensusById(censusId) {
        let url = `/census/${censusId}`;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    getCensusByCriteria(unitIds, censusYear, statuses, fromDate, toDate) {
        let url = "/census"
        let params = null;
        params = {unitIds: unitIds, censusYear: censusYear, statuses: statuses}

        if (fromDate != null || toDate != null) {
            params = {unitIds: unitIds, statuses: statuses, dateStart: fromDate, dateEnd: toDate}
        } else {
            params = {unitIds: unitIds, censusYear: censusYear, statuses: statuses}
        }
        console.log(params)
        return axios.get(MEMBERS_BASE_URL + url, {
            headers: getHeaders(),
            params: params,
            paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
        });
    }

    getCensusFreeMembersByCriteria(unitId, censusYear) {
        let url = "/unit/" + unitId + "/census_free"
        let params = {year: censusYear}
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params})
    }

    addCensus(memberIds, orgUnit, replacementIds, year) {
        let url = "/census"
        let params = {memberIds: memberIds, orgUnit: orgUnit, replacementIds: replacementIds, year: year}
        return axios.post(MEMBERS_BASE_URL + url, params, {headers: getHeaders()});
    }

    removeCensus(censusId) {
        let url = "/census/" + censusId;
        return axios.delete(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    submitCensus(censusId) {
        let url = "/census/" + censusId + "/submit";
        return axios.put(MEMBERS_BASE_URL + url, {}, {headers: getHeaders()});
    }

    submitManualCensus(census) {
        let url = "/census/" + census.id + "/submit/manual";

        return axios.put(MEMBERS_BASE_URL + url, census, {headers: getHeaders()})
    }

    /* ---  Billing Methods services --- */

    getBillingMethodsByCriteria() {
        let url = "/billing/method";
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()})
    }

    addBillingMethod(method) {
        let url = "/billing/method";
        return axios.post(MEMBERS_BASE_URL + url, method, {headers: getHeaders()});
    }

    editBillingMethod(method) {
        let url = "/billing/method/" + method.id;
        return axios.put(MEMBERS_BASE_URL + url, method, {headers: getHeaders()})
    }

    deleteBillingMethod(methodId) {
        let url = "/billing/method/" + methodId;
        return axios.delete(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    addRuleToMethod(methodId, rule) {
        let url = "/billing/method/" + methodId + "/rule";
        let params = {billingValue: rule.billingValue * 100, rule: rule.rule}
        return axios.post(MEMBERS_BASE_URL + url, params, {headers: getHeaders()})
    }

    deleteRule(methodId, ruleId) {
        let url = "/billing/method/" + methodId + "/rule/" + ruleId;
        return axios.delete(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    /* --- Licenses Services --- */

    createLicenseProposal(licenseProposal) {
        let url = "/license/proposal";
        licenseProposal.desiredDate = moment(licenseProposal.desiredDate).isValid() ? moment(licenseProposal.desiredDate).format('YYYY-MM-DD') : null;
        licenseProposal.desiredEndDate = moment(licenseProposal.desiredEndDate).isValid() ? moment(licenseProposal.desiredEndDate).format('YYYY-MM-DD') : null;
        console.log(licenseProposal)
        return axios.post(MEMBERS_BASE_URL + url, licenseProposal, {headers: getHeaders()})
    }

    getLicensesProposalById(proposalId) {
        let url = "/license/proposal/" + proposalId;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()})
    }

    getLicensesProposalsByCriteria(statuses, unitId = null, search = null, includeSubs = false, proposalType = null, memberId = null) {
        // Getting Licenses Proposals
        let url = "/license/proposal";
        let params = {
            statuses: statuses,
            unitId: unitId,
            search: search,
            includeSubs: includeSubs,
            proposalType: proposalType,
            memberId: memberId
        }
        return axios.get(MEMBERS_BASE_URL + url, {
            headers: getHeaders(),
            params: params,
            paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
        })
    }

    getLicensesByUnit(unitId) {
        let url = "/unit/" + unitId + "/licenses"
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    approveLicense(proposalId, comments, approve, desiredEndDate, desiredDate, acceptedStatutoryDeclaration=false, acceptedRegulatoryDeclaration=false) {
        let url = "/license/proposal/" + proposalId + "/approve";
        desiredDate = moment(desiredDate).isValid() ? moment(desiredDate).format('YYYY-MM-DD') : null;
        desiredEndDate = moment(desiredEndDate).isValid() ? moment(desiredEndDate).format('YYYY-MM-DD') : null;
        return axios.put(MEMBERS_BASE_URL + url, {
            approval: approve,
            comments: comments,
            desiredEndDate: desiredEndDate,
            desiredDate: desiredDate,
            acceptedStatutoryDeclaration: acceptedStatutoryDeclaration,
            acceptedRegulatoryDeclaration: acceptedRegulatoryDeclaration
        }, {headers: getHeaders()});
    }

    cancelLicenseProposal(proposalId) {
        let url = "/license/proposal/" + proposalId + "/cancel";
        return axios.put(MEMBERS_BASE_URL + url, {}, {headers: getHeaders()});
    }

    getAvailableTitles(unitId, includeSubs = false) {
        let url = "/unit/" + unitId + "/available_titles";
        let params = {includeSubs: includeSubs};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    getLicensesByMember(memberId, active = true) {
        let url = "/member/" + memberId + "/licenses"
        let params = {active: active};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    getLicenseProposalEndDate(memberId, unitId, type, title, desiredDate) {
        let url = "/license/proposal/end_date";
        desiredDate = moment(desiredDate).isValid() ? moment(desiredDate).format('YYYY-MM-DD') : null;
        let params = {desiredDate: desiredDate, type: type, title: title, unitId: unitId, memberId: memberId};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    /* --- Support Members Services --- */

    getSupportCommission(unitId, status) {
        let url = "/support_commission";
        let params = {unitId: unitId, status: status};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    changeSupportMemberTitle(supportMember, comments) {
        let url = "/support_member/" + supportMember.id;
        return axios.put(MEMBERS_BASE_URL + url, {
            supportMember: supportMember,
            comment: comments
        }, {headers: getHeaders()})
    }

    approveSupportCommission(supportCommissionId, approved, comments, dueDate) {
        let url = "/support_commission/" + supportCommissionId + "/approve";
        dueDate = moment(dueDate).format('YYYY-MM-DD');
        return axios.put(MEMBERS_BASE_URL + url, {
            approved: approved,
            comments: comments,
            desiredDueDate: dueDate
        }, {headers: getHeaders()})
    }

    getSupportMemberHistory(memberId, title) {
        let url = "/member/" + memberId + "/support_commission_history";
        let params = {continuous: true, title: title};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    getAvailableCommissionsToExpire(unitId = null) {
        let url = "/support_commission/expirable";
        let params = {unit_id: unitId};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    proposeCommission(selectedUnitId, supportCommission) {
        let url = "/unit/" + selectedUnitId + "/support_commission";
        supportCommission.dueDate = moment(supportCommission.dueDate).format('YYYY-MM-DD');
        supportCommission.proposedDate = moment(supportCommission.proposedDate).format('YYYY-MM-DD');
        return axios.post(MEMBERS_BASE_URL + url, supportCommission, {headers: getHeaders()});
    }

    updateCommission(selectedUnitId, supportCommission) {
        let url = "/unit/" + selectedUnitId + "/support_commission";
        supportCommission.dueDate = moment(supportCommission.dueDate).format('YYYY-MM-DD');
        return axios.put(MEMBERS_BASE_URL + url, supportCommission, {headers: getHeaders()});
    }

    expireCommission(supportId, comments) {
        let url = "/support_commission/" + supportId + "/expire";
        return axios.put(MEMBERS_BASE_URL + url, {comments: comments}, {headers: getHeaders()})
    }

    cancelCommission(supportId) {
        let url = "/support_commission/" + supportId + "/cancel";
        return axios.delete(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    /* ----- Conference Services ---------------------- */

    getConferenceMembers(status = null) {
        let url = "/conference";
        let params = {status: status};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    createConferenceMember(member) {
        let url = "/conference";
        return axios.post(MEMBERS_BASE_URL + url, member, {headers: getHeaders()});
    }

    editConferenceMember(member) {
        let url = "/conference/" + member.id
        return axios.put(MEMBERS_BASE_URL + url, member, {headers: getHeaders()});
    }

    /* --- Reports Services --- */

    getReport(report_type, params) {
        let url = REPORT_MAP[report_type];
        params.fromDate = params.fromDate ? moment(params.fromDate).format('YYYY-MM-DD') : null;
        params.toDate = params.toDate ? moment(params.toDate).format('YYYY-MM-DD') : null;
        return axios.get(url, {
            headers: getHeaders(),
            params: params,
            paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
        });
    }


    getPaginatedReport(report_type, params, paged, pageSize, pageNumber) {
        let url = REPORT_MAP[report_type];
        params.paged = paged;
        params.size = pageSize;
        params.page = pageNumber;
        params.fromDate = params.fromDate ? moment(params.fromDate).format('YYYY-MM-DD') : null;
        params.toDate = params.toDate ? moment(params.toDate).format('YYYY-MM-DD') : null;
        return axios.get(url, {
            headers: getHeaders(),
            params: params,
            paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
        });
    }



    downloadReportExcel(report_type, params) {
        let url = REPORT_MAP[report_type] + "/excel";
        params.fromDate = params.fromDate ? moment(params.fromDate).format('YYYY-MM-DD') : null;
        params.toDate = params.toDate ? moment(params.toDate).format('YYYY-MM-DD') : null;
        return axios.get(url, {
            headers: getHeaders(),
            params: params,
            paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'}),
            responseType: 'blob'
        });
    }

    /* --- Modules Services --- */

    getModules() {
        let url = '/module';
        let params = {active: true, moduleType: 'FLEX_MODULE'};
        return axios.get(TRAINING_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    /* --- Training Leaders Services ---*/
    downloadLeadersLogbook(memberId) {
        let url = `/license/${memberId}/logbook/excel`;
        return axios.get(TRAINING_BASE_URL + url, {headers: getHeaders(), params: null, responseType: 'blob'})
    }


    /* --- Gatherings Services ---*/

    getJamborees() {
        let url = '/jamboree';
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    updateJamboree(jamboree) {
        let url = "/jamboree/" + jamboree.id
        return axios.put(MEMBERS_BASE_URL + url, jamboree, {headers: getHeaders()});
    }

    createJamboree(jamboree) {
        let url = "/jamboree"
        return axios.post(MEMBERS_BASE_URL + url, jamboree, {headers: getHeaders()});
    }

    getJamboreePaymentById(id) {
        let url = `/jamboree/payment/${id}`;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    updateJamboreePayment(jamboreePayment, skipConvertion = false) {
        let url = "/jamboree/payment/" + jamboreePayment.id;
        let body = structuredClone(jamboreePayment);
        if (!skipConvertion) {
            body.paymentMembers = jamboreePayment.paymentMembers.map(x => ({...x, amount: x.amount * 100}));
        }
        return axios.put(MEMBERS_BASE_URL + url, body, {headers: getHeaders()});
    }

    createJamboreePayment(jamboreePayment, skipConvertion = false) {
        let url = "/jamboree/payment/";
        let body = structuredClone(jamboreePayment);
        if (!skipConvertion) {
            body.paymentMembers = jamboreePayment.paymentMembers.map(x => ({...x, amount: x.amount * 100}));
        }
        return axios.post(MEMBERS_BASE_URL + url, body, {headers: getHeaders()});
    }

    submitJamboreePayment(jamboreePayment, skipConvertion = false) {
        let url = `/jamboree/payment/${jamboreePayment.id}/submit`
        let body = structuredClone(jamboreePayment);
        if (!skipConvertion) {
            body.paymentMembers = jamboreePayment.paymentMembers.map(x => ({...x, amount: x.amount * 100}));
        }
        return axios.put(MEMBERS_BASE_URL + url, body, {headers: getHeaders()});
    }

    deleteJamboreePayment(jamboreePayment) {
        let url = `/jamboree/payment/${jamboreePayment.id}`
        return axios.delete(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }


    getJamboreePayments(selectedjamboree ,unit = null) {
        let url = '/jamboree/payment';
        let params = {jamboreeId: selectedjamboree?.id ,unitId: unit?.id};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    getJamboreeApplications(selectedjamboree, unit = null) {
        let url = '/jamboree/application';
        let params = {jamboreeId: selectedjamboree?.id,unitId: unit?.id};
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params: params});
    }

    submitJamboreeApplication(jamboreeApplication) {
        let url = `/jamboree/application/${jamboreeApplication.id}/submit`
        let body = structuredClone(jamboreeApplication);
        return axios.put(MEMBERS_BASE_URL + url, body, {headers: getHeaders()});
    }

    deleteJamboreeApplication(jamboreeApplication) {
        let url = `/jamboree/application/${jamboreeApplication.id}`
        return axios.delete(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    createJamboreeApplication(jamboreeApplication) {
        let url = "/jamboree/application";
        return axios.post(MEMBERS_BASE_URL + url, jamboreeApplication, {headers: getHeaders()});
    }

    getJamboreeApplicationById(id) {
        let url = `/jamboree/application/${id}`;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    updateJamboreeApplication(jamboreeApplication) {
        let url = "/jamboree/application/" + jamboreeApplication.id;
        return axios.put(MEMBERS_BASE_URL + url, jamboreeApplication, {headers: getHeaders()});
    }



    getMemberDiscComments(memberId) {
        let url = `/member/${memberId}/disciplinary`;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    createMemberDiscComments(memberId, comment) {
        let url = `/member/${memberId}/disciplinary`;

        let body = {comment: comment}

        return axios.post(MEMBERS_BASE_URL + url, body, {headers: getHeaders()});
    }
    
    getHonours(memberId) {
        let url = `/member/${memberId}/honours`;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }
    
    createMemberHonours(memberId, honour) {
        let url = `/member/${memberId}/honours`;
        

        return axios.post(MEMBERS_BASE_URL + url, honour, {headers: getHeaders()});
    }
    
    deleteMemberHonours(memberId, honourId) {
        let url = `/member/${memberId}/honours/${honourId}`;
        
        return axios.delete(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    canApproveJamboreeApplication(applicationId) {
        let url = `/jamboree/application/${applicationId}/approve`;
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders()});
    }

    approveRejectJamboreeApplication(jamboreeApplication, payload) {
        let url = `/jamboree/application/${jamboreeApplication.id}/approve`
        return axios.put(MEMBERS_BASE_URL + url, payload, {headers: getHeaders()});
    }

    getJamboreeApprovedMembers(jamboreeId, memberId) {
        let url = `/jamboree/${jamboreeId}/approved/${memberId}`

        return axios.get(MEMBERS_BASE_URL + url, {
            headers: getHeaders(),
        });
    }

    uploadFile(memberId, file, type, information=null) {
        let url = `/member/${memberId}/attachment/upload`;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", type);
        formData.append("information", information);

        return axios.post(MEMBERS_BASE_URL + url, formData, { headers: getHeaders(), 'content-type': 'multipart/form-data' })
    }


    getMemberAttachments(memberId) {
        let url = `/member/${memberId}/attachment`;
        return axios.get(MEMBERS_BASE_URL + url, { headers: getHeaders()});
    }

    downloadAttachment(memberId, file) {
        let url = `/member/${memberId}/attachment/${file.id}/download`;
        return axios.get(MEMBERS_BASE_URL + url, { headers: getHeaders(), responseType: 'blob'});
    }


    deleteFile(memberId, attachmentId) {
        let url = `/member/${memberId}/attachment/${attachmentId}/delete`;
        return axios.delete(MEMBERS_BASE_URL + url, { headers: getHeaders() });
    }

}

const REPORT_MAP = {
    support_members: MEMBERS_BASE_URL + "/report/support_members",
    old_hq_members: MEMBERS_BASE_URL + "/report/old_hq_members",
    census_member_history: MEMBERS_BASE_URL + "/report/census_member_history",
    census_total: MEMBERS_BASE_URL + "/report/census_total",
    unit: MEMBERS_BASE_URL + "/report/unit",
    census: MEMBERS_BASE_URL + "/report/census",
    members: MEMBERS_BASE_URL + "/report/members",
    member_licenses: MEMBERS_BASE_URL + "/report/member_licenses",
    license_proposal: MEMBERS_BASE_URL + "/report/license_proposal",
    election_eligible: MEMBERS_BASE_URL + "/report/election_eligible",
    profile: TRAINING_BASE_URL  + "/report/profile",
    activity: TRAINING_BASE_URL + "/report/activity",
    participations: TRAINING_BASE_URL + "/report/participations",
    diploma: TRAINING_BASE_URL + "/report/diploma",
    trainer: TRAINING_BASE_URL + "/report/trainer",
    conference: MEMBERS_BASE_URL + "/report/conference",
    applyActivities: TRAINING_BASE_URL + "/report/apply_activities",
    progress: ACHIEVEMENT_BASE_URL + "/report/progress/",
    evaluationCriterias: ACHIEVEMENT_BASE_URL + "/report/evaluation_criteria",
    jamboree: MEMBERS_BASE_URL  + "/report/jamboree",
    jamboree_payment: MEMBERS_BASE_URL  + "/report/jamboree_payments",
    excursion: EXCURSION_BASE_URL + "/report/attendance",
    trainingNeeds: TRAINING_BASE_URL + "/report/training_need",
    users: SSO_BASE_URL + "/report/users",
    member_honours: MEMBERS_BASE_URL  + "/report/honours",
}

export default new EsepMemberService();